import { render, staticRenderFns } from "./StudentViewTabStudy.vue?vue&type=template&id=466bf7f1&"
import script from "./StudentViewTabStudy.vue?vue&type=script&lang=js&"
export * from "./StudentViewTabStudy.vue?vue&type=script&lang=js&"
import style0 from "./StudentViewTabStudy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports